import { render, staticRenderFns } from "./licensedetail.vue?vue&type=template&id=fe7dd00a"
import script from "./licensedetail.vue?vue&type=script&lang=js"
export * from "./licensedetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports